// A kit button goes down on touch within the same frame as the finger, in every browser (FEEL-08).
//
// kit.css styles `.pb:active`, but iOS Safari does not apply :active to a touch unless the page has a touch listener
// of its own, and a quick tap releases before a frame has painted the pressed pad. So on a touch or pen press this
// sets the `.pressed` class (styled the same as :active) on pointerdown and holds it for at least HOLD_MS after the
// release, which is about four frames: long enough to be seen, short enough to feel instant.
const HOLD_MS = 70;

if (typeof window !== 'undefined') {
  let down: { el: Element; at: number } | null = null;
  const release = () => {
    if (!down) return;
    const { el, at } = down;
    down = null;
    const left = HOLD_MS - (performance.now() - at);
    if (left > 0) window.setTimeout(() => el.classList.remove('pressed'), left);
    else el.classList.remove('pressed');
  };
  window.addEventListener('pointerdown', (ev) => {
    if (ev.pointerType === 'mouse' || !(ev.target instanceof Element)) return;
    const el = ev.target.closest('.pb');
    if (!el || (el as HTMLButtonElement).disabled || el.getAttribute('aria-disabled') === 'true') return;
    release();
    el.classList.add('pressed');
    down = { el, at: performance.now() };
  }, true);
  window.addEventListener('pointerup', release, true);
  window.addEventListener('pointercancel', release, true);
}
export {};
